import megacheck from "~/assets/icons/megacheck.png";

export function MegaCheck() {
    return (
        <img
            src={megacheck}
            alt="success"
            class="mx-auto w-1/2 max-w-[50vh] flex-shrink"
        />
    );
}
